import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { getAPI } from "./Networking";
import {
  OrderTrackingAveragesResponse,
  OrderTrackingPipelinePaginatedResponse,
} from "../models/Dashboard/OrderTracking/OrderTrackingAnalytics";
import { OrderTrackingAnalyticsAPIFilters } from "../models/Dashboard/OrderTracking/OrderTrackingAnalyticsFilters";

dayjs.extend(utc);

export default class OrderTrackingAnalyticsAPI {
  private buildQueryParams = (
    filters: OrderTrackingAnalyticsAPIFilters,
    includePagination = false,
  ): URLSearchParams => {
    const start_date = dayjs(filters.start_date, "YYYY-MM-DD")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    const end_date = dayjs(filters.end_date, "YYYY-MM-DD")
      .add(1, "day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    const queryParams = new URLSearchParams();
    queryParams.append("start_date", start_date);
    queryParams.append("end_date", end_date);

    if (filters.order_type_id.length > 0) {
      queryParams.append(
        "order_type_id",
        filters.order_type_id.map((item) => item.id).join(","),
      );
    }

    if (filters.order_id.length > 0) {
      queryParams.append(
        "order_id",
        filters.order_id.map((item) => item.id).join(","),
      );
    }

    if (filters.sales_poc_id.length > 0) {
      queryParams.append(
        "sales_poc_id",
        filters.sales_poc_id.map((item) => item.id).join(","),
      );
    }

    if (filters.pm_poc_id.length > 0) {
      queryParams.append(
        "pm_poc_id",
        filters.pm_poc_id.map((item) => item.id).join(","),
      );
    }

    if (filters.customer_id.length > 0) {
      queryParams.append(
        "customer_id",
        filters.customer_id.map((item) => item.id).join(","),
      );
    }

    if (filters.stage) {
      queryParams.append("stage", filters.stage);
    }

    if (includePagination) {
      queryParams.append("page_no", String(filters.page_no ?? 1));
      queryParams.append("limit", String(filters.limit ?? 30));
      if (filters.sort_by) queryParams.append("sort_by", filters.sort_by);
      if (filters.sort_type) queryParams.append("sort_type", filters.sort_type);
    }

    return queryParams;
  };

  getAverages = async (
    filters: OrderTrackingAnalyticsAPIFilters,
  ): Promise<OrderTrackingAveragesResponse> => {
    try {
      const queryParams = this.buildQueryParams(filters);
      const response = await getAPI(
        `/v1/order-tracking/averages?${queryParams.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getPipeline = async (
    filters: OrderTrackingAnalyticsAPIFilters,
  ): Promise<OrderTrackingPipelinePaginatedResponse> => {
    try {
      const queryParams = this.buildQueryParams(filters, true);
      const response = await getAPI(
        `/v1/order-tracking/pipeline?${queryParams.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
